<template>
  <header class="login-forms-header header">
    <app-button class="btn btn-round btn-primary"
                :label="$t('message.loginPersonalize.message.createCustomization')"                
                @click="openCreateModal" />

    <login-personalize-create-modal v-model="showingCreateModal" />
  </header>
</template>

<script>
import AppButton from "@/components/generic/button/Button";
import LoginPersonalizeCreateModal from "@components/modules/login-personalize/create/modal/LoginPersonalizeCreateModal";

export default {
  components: {
    AppButton,
    LoginPersonalizeCreateModal,
  },

  data() {
    return {
      showingCreateModal: false,
    };
  },

  computed: {},

  methods: {
    openCreateModal() {
      this.showingCreateModal = true;
    },
    goToCreatePage() {
      this.$router.push(`/personalizar-login/criar`);
    },
  },

  watch: {},
};
</script>

<style lang="scss" scoped>
.login-forms-header {
  display: flex;
  align-items: center;
}
</style>
